import { Component } from '@angular/core';
import BaseComponent from '../BaseComponent';
import { SaveTypes } from 'app/models/enums/SaveTypes';
import { QuillConfig } from '../../../shared/quill/quill-config';
import { CustomerKeyValuePairService } from '../../../services/customer-keyvaluepair.service';
import CustomerHelper from 'app/managecustomer/CustomerHelper';
import { finalize, forkJoin, of, switchMap } from 'rxjs';
import Utils from '../../../shared/utils';

@Component({
    selector: 'app-components-ticket-emailsettings',
    templateUrl: './email-settings.component.html'
})
export class EmailSettingsComponent extends BaseComponent {
  isOpen = false;
  onboardingRecapEmailActionItems: string;
  quillModules: any = QuillConfig.GetDefaults().modules;
  
  constructor(private customerKeyValuePairService: CustomerKeyValuePairService) { 
    super();
  }

  activate(params: app.ticket.components.interfaces.ITicketComponentActivateParams): JQueryPromise<void> {
    this.isLoading(true);
    return super.activate(params)
      .then(() => {
          return Utils.wrapDfd(
              forkJoin([
                  this.customerKeyValuePairService.get(this.customer.CustomerId()),
              ])
              .pipe(
                  switchMap(([keys]) => {
                      this.onboardingRecapEmailActionItems = CustomerHelper.getValue(keys, Boo.Objects.Enums.KeyEnum.OnboardingRecapActionItems);
                      return of(null);
                  }),
                  finalize(() => this.isLoading(false))
              )
          )
      });
  }

  save(saveType: SaveTypes): JQueryPromise<app.ticket.interfaces.ISaveData | void> {
    this.isLoading(true);
    return this.SaveCustomerKeyValuePairRecapEmailActionItems()
      .then(() => super.save(saveType));
  }

  SaveCustomerKeyValuePairRecapEmailActionItems(): JQueryPromise<void> {
    return Utils.wrapDfd(this.customerKeyValuePairService.get(this.customer.CustomerId()))
      .then(customerKeyValuePairs => {
          CustomerHelper.setValue(customerKeyValuePairs, this.customer.CustomerId(), this.user.UserId, Boo.Objects.Enums.KeyEnum.OnboardingRecapActionItems, this.onboardingRecapEmailActionItems);
          return Utils.wrapDfd(this.customerKeyValuePairService.save(CustomerHelper.getCustomerKeyValuePair(customerKeyValuePairs, Boo.Objects.Enums.KeyEnum.OnboardingRecapActionItems)));
      });
  }
}